export const getMcnDeductColumns = () => {
    return [
        { headerName: "Employee", key: "employee" },
        { headerName: "Type", key: "type" },
        { headerName: "Start Date", key: "start_date" },
        { headerName: "End Data", key: "end_date" },
        { headerName: "Deduction", key: "deduction" },
        { headerName: "Deduction Cap", key: "deduction_gap" },
        { headerName: "Description", key: "description" },
        { headerName: "", key: "action" },
    ];
}

export const getChildSupportDeductColumns = () => {
    return [
        { headerName: "Employee", key: "employee" },
        { headerName: "Type", key: "type" },
        { headerName: "Start Date", key: "start_date" },
        { headerName: "End Data", key: "end_date" },
        { headerName: "Deduction", key: "deduction" },
        { headerName: "Max Percent", key: "max_percent" },
        { headerName: "Description", key: "description" },
        { headerName: "", key: "action" },
    ];
}